import throttle from 'lodash/throttle';

async function loadSwiper() {
	try {
		const { default: Swiper } = await import('swiper');
		const { Autoplay, Navigation, EffectFade } = await import(
			'swiper/modules'
		);
		return { Swiper, Navigation, Autoplay, EffectFade };
	} catch (error) {
		console.error('Failed loading Swiper', error); //eslint-disable-line
	}
}

const heroDisplayTabChangers = document.querySelectorAll(
	'.block-hero-tab-changer'
);

if (heroDisplayTabChangers.length > 0) {
	(async () => {
		const { Swiper, Navigation, Autoplay, EffectFade } = await loadSwiper();
		const swiperElements = document.querySelectorAll(
			'.block-hero-tab-changer__container'
		);
		const tabs = document.querySelectorAll('.block-hero-tab-changer__tab');
		const tabButtons = document.querySelectorAll(
			'.block-hero-tab-changer__tab-button'
		);
		const swiperInstances = new Map();
		let swiperIsMobile = null;

		const createSwiper = (element, mobile = true) => {
			const params = mobile
				? {
						loop: true,
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
						modules: [Navigation],
					}
				: {
						loop: true,
						autoplay: {
							delay: 5000,
						},
						effect: 'fade',
						fadeEffect: {
							crossFade: true,
						},
						modules: [Autoplay, Navigation, EffectFade],
						on: {
							afterInit: (swiper) => {
								changeSwiperSlide(swiper.realIndex);
							},
							realIndexChange: (swiper) => {
								changeSwiperSlide(
									swiper.realIndex,
									swiper.previousRealIndex
								);
							},
						},
					};

			return new Swiper(element, params);
		};

		const changeSwiperSlide = (index, prevIndex) => {
			tabs[prevIndex]?.classList.remove('active');
			tabs[index]?.classList.add('active');
		};

		const destroySwiper = (key) => {
			swiperInstances.get(key)?.destroy(true, true);
			swiperInstances.delete(key);
		};

		const checkViewportWidth = () => {
			const isMobile = window.matchMedia('(max-width: 768px)').matches;

			for (const swiperElement of swiperElements) {
				if (isMobile && true !== swiperIsMobile) {
					swiperIsMobile = true;

					// Destroy desktop swiper
					if (swiperInstances.has(swiperElement)) {
						destroySwiper(swiperElement);
					}

					swiperInstances.set(
						swiperElement,
						createSwiper(swiperElement)
					);
				} else if (!isMobile && false !== swiperIsMobile) {
					swiperIsMobile = false;

					// Destroy mobile swiper
					if (swiperInstances.has(swiperElement)) {
						destroySwiper(swiperElement);
					}

					const swiper = createSwiper(swiperElement, false);

					// Create new desktop swiper
					swiperInstances.set(swiperElement, swiper);

					// Add tab button click handlers to change swiper slide
					tabButtons.forEach((button, index) => {
						button.addEventListener('click', () => {
							swiper.slideToLoop(index);
						});
					});
				}
			}
		};

		window.addEventListener('load', checkViewportWidth);
		window.addEventListener('resize', throttle(checkViewportWidth, 100));
	})();
}
